import React, { useState } from 'react'

interface QuizHintToggleProps {
  hint: string
  disabled?: boolean
}

/**
 * 퀴즈 힌트 토글 컴포넌트
 * - 문제 아래, 선택지 위에 위치
 * - 기본 접힘 상태, 클릭 시 펼침/접힘
 * - 답 제출 후 disabled=true로 숨김
 */
export const QuizHintToggle: React.FC<QuizHintToggleProps> = ({ hint, disabled }) => {
  const [isOpen, setIsOpen] = useState(false)

  if (disabled) return null

  return (
    <div className="my-3">
      <button
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        className="flex items-center gap-1.5 text-sm font-medium text-blue-600 hover:text-blue-700 transition-colors"
      >
        <span className="text-base">💡</span>
        <span>{isOpen ? '힌트 숨기기' : '힌트 보기'}</span>
        <svg
          className={`w-4 h-4 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      <div
        className={`overflow-hidden transition-all duration-200 ease-in-out ${
          isOpen ? 'max-h-96 opacity-100 mt-2' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="bg-blue-50 border border-blue-200 rounded-lg px-4 py-3 text-sm text-blue-800">
          {hint}
        </div>
      </div>
    </div>
  )
}

export default QuizHintToggle
